import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_GROUP_CREATE = gql `
  mutation AdminWineryCreate($input: AdminWineryCreateInput!) {
    AdminWineryCreate(input: $input)
  }
`;
